(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["eros-model-label"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__erosModelLabelInit) return;
    window.__erosModelLabelInit = true;

    function init() {
      var templates = document.querySelectorAll('template[data-eros-model-label]');
      if (!templates.length) return;
      var gallery = document.querySelector('.product-information__media, .media-gallery, media-gallery, .product-media-gallery');
      if (!gallery) return;
      // Ensure positioning context
      var cs = getComputedStyle(gallery);
      if (cs.position === 'static') gallery.style.position = 'relative';
      // Remove any previously injected label
      gallery.querySelectorAll('.eros-model-label').forEach(function (el) { el.remove(); });
      // Use the first template (usually only one)
      var tpl = templates[0];
      var node = tpl.content.firstElementChild.cloneNode(true);
      gallery.appendChild(node);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["eros-pdp-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    function labelOf(k) {
      var map = {
        chest: 'Chest', length: 'Length', shoulder: 'Shoulder', shoulders: 'Shoulders',
        waist: 'Waist', hip: 'Hip', sleeve: 'Sleeve', inseam: 'Inseam',
        width: 'Width', height: 'Height', front_rise: 'Front Rise',
        leg_opening: 'Leg Opening', front_crotch: 'Front Crotch', armpit: 'Armpit'
      };
      return map[k] || k.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    function render(el) {
      var raw = el.textContent.trim();
      if (!raw) return;
      var data;
      try { data = JSON.parse(raw); if (typeof data === 'string') data = JSON.parse(data); } catch (e) { return; }
      if (!data || !data.sizes) return;
      var skip = { size: 1, name: 1, height_range: 1, weight_range: 1 };
      var fields = [], seen = {};
      data.sizes.forEach(function (s) {
        for (var k in s) {
          if (skip[k] || seen[k] || s[k] == null || s[k] === '') continue;
          seen[k] = 1; fields.push(k);
        }
      });
      var html = '<table class="eros-acc__chart-table"><thead><tr><th>Size</th>';
      fields.forEach(function (f) { html += '<th>' + labelOf(f) + '</th>'; });
      html += '</tr></thead><tbody>';
      data.sizes.forEach(function (s) {
        html += '<tr><td>' + (s.size || s.name || '') + '</td>';
        fields.forEach(function (f) { html += '<td>' + (s[f] != null && s[f] !== '' ? s[f] : '\u2014') + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';
      el.outerHTML = html;
    }
    function init() { document.querySelectorAll('[data-eros-chart]').forEach(render); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["eros-size-advisor"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    if (window.__erosSaInit) return;
    window.__erosSaInit = true;

    function initRoot(root) {
      if (root.dataset.saInited) return;
      root.dataset.saInited = '1';

      var openBtn = root.querySelector('[data-sa-open]');
      var modal = root.querySelector('[data-sa-modal]');
      var chartScript = root.querySelector('[data-sa-chart]');
      var variantsScript = root.querySelector('[data-sa-variants]');
      if (!openBtn || !modal || !chartScript) return;

      var chart = null;
      try { chart = JSON.parse(chartScript.textContent); } catch (e) { return; }
      if (!chart || !chart.sizes) return;

      var variants = [];
      try { variants = JSON.parse(variantsScript.textContent || '[]'); } catch (e) { variants = []; }

      var stepOrder = ['intro', 'height', 'weight', 'usual', 'fit', 'result'];
      var state = {
        step: 'intro', heightUnit: 'cm', weightUnit: 'kg',
        height_cm: null, height_ft: null, height_in: null,
        weight_kg: null, weight_lb: null,
        usual: null, fit: null, result: null,
      };

      var productId = root.dataset.productId;
      var savedKey = 'eros-sa-' + productId;
      var globalKey = 'eros-sa-global';
      // Prefill from global saved profile (any previous size advisor session)
      try {
        var glob = JSON.parse(localStorage.getItem(globalKey) || 'null');
        if (glob) {
          if (glob.height_cm) { state.height_cm = glob.height_cm; var inp = root.querySelector('[data-sa-field="height_cm"]'); if (inp) inp.value = glob.height_cm; }
          if (glob.weight_kg) { state.weight_kg = glob.weight_kg; var inp2 = root.querySelector('[data-sa-field="weight_kg"]'); if (inp2) inp2.value = glob.weight_kg; }
          if (glob.usual) { state.usual = glob.usual; var sb = root.querySelector('[data-sa-options="usual"] [data-sa-value="' + glob.usual + '"]'); if (sb) sb.classList.add('is-selected'); }
          if (glob.fit) { state.fit = glob.fit; var fb = root.querySelector('[data-sa-options="fit"] [data-sa-value="' + glob.fit + '"]'); if (fb) fb.classList.add('is-selected'); }
        }
      } catch (e) {}
      var savedBadge = root.querySelector('[data-sa-saved-badge]');
      try {
        var saved = localStorage.getItem(savedKey);
        if (saved) {
          var parsed = JSON.parse(saved);
          if (parsed && parsed.recommended && savedBadge) {
            savedBadge.textContent = '· Recommended for you: ' + parsed.recommended;
            savedBadge.hidden = false;
          }
        } else {
          var glob2 = localStorage.getItem(globalKey);
          if (glob2) {
            var p2 = JSON.parse(glob2);
            if (p2 && p2.last_size && savedBadge) {
              savedBadge.textContent = '· Last recommended: ' + p2.last_size;
              savedBadge.hidden = false;
            }
          }
        }
      } catch (e) {}

      function showStep(name) {
        state.step = name;
        root.querySelectorAll('[data-sa-step]').forEach(function (el) {
          el.hidden = el.dataset.saStep !== name;
        });
        validateStep();
      }

      function nextStep() {
        var idx = stepOrder.indexOf(state.step);
        if (idx >= 0 && idx < stepOrder.length - 1) {
          var next = stepOrder[idx + 1];
          if (next === 'result') compute();
          showStep(next);
        }
      }
      function prevStep() {
        var idx = stepOrder.indexOf(state.step);
        if (idx > 0) showStep(stepOrder[idx - 1]);
      }

      function openModal() { modal.hidden = false; document.body.classList.add('eros-sa-open'); showStep('intro'); }
      function closeModal() { modal.hidden = true; document.body.classList.remove('eros-sa-open'); }

      openBtn.addEventListener('click', openModal);
      root.querySelectorAll('[data-sa-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
      root.querySelectorAll('[data-sa-next]').forEach(function (b) { b.addEventListener('click', nextStep); });
      root.querySelectorAll('[data-sa-back]').forEach(function (b) { b.addEventListener('click', prevStep); });

      // Unit toggles
      root.querySelectorAll('[data-sa-unit-group]').forEach(function (group) {
        var groupName = group.dataset.saUnitGroup;
        group.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var unit = b.dataset.saUnit;
            group.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active');
            if (groupName === 'height') state.heightUnit = unit;
            else state.weightUnit = unit;
            var parent = group.parentElement;
            parent.querySelectorAll('[data-sa-unit-view]').forEach(function (v) {
              v.hidden = v.dataset.saUnitView !== unit;
            });
            validateStep();
          });
        });
      });

      // Numeric inputs
      root.querySelectorAll('[data-sa-field]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var val = inp.value === '' ? null : Number(inp.value);
          state[inp.dataset.saField] = val;
          validateStep();
        });
      });

      // Option buttons (usual, fit)
      root.querySelectorAll('[data-sa-options]').forEach(function (container) {
        var key = container.dataset.saOptions;
        container.querySelectorAll('button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            container.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            state[key] = btn.dataset.saValue;
            validateStep();
          });
        });
      });

      // View chart from anywhere
      root.querySelectorAll('[data-sa-view-chart]').forEach(function (b) {
        b.addEventListener('click', function () {
          root.dataset.saChartReturn = state.step;
          renderChart();
          showStep('chart');
        });
      });
      root.querySelectorAll('[data-sa-chart-back]').forEach(function (b) {
        b.addEventListener('click', function () { showStep(root.dataset.saChartReturn || 'intro'); });
      });

      // Retake quiz
      root.querySelectorAll('[data-sa-retake]').forEach(function (b) {
        b.addEventListener('click', function () { showStep('intro'); });
      });

      // Add to cart
      root.querySelectorAll('[data-sa-add-to-cart]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!state.result) return;
          var v = pickVariantForSize(state.result);
          if (!v) return;
          var fd = new FormData();
          fd.append('id', v.id);
          fd.append('quantity', '1');
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function (r) { return r.json(); })
            .then(function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
              if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cart) {
                try { window.Shopify.theme.cart.open(); } catch (e) {}
              }
              closeModal();
            });
        });
      });

      // Save email/preference
      var emailForm = root.querySelector('[data-sa-email-form]');
      if (emailForm) {
        emailForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = (emailForm.querySelector('input[name="email"]') || {}).value;
          try {
            localStorage.setItem(savedKey, JSON.stringify({ recommended: state.result, email: email, ts: Date.now() }));
            try { localStorage.setItem(globalKey, JSON.stringify({ height_cm: state.height_cm, weight_kg: state.weight_kg, usual: state.usual, fit: state.fit, last_size: state.result, ts: Date.now() })); } catch (e2) {}
            var status = root.querySelector('[data-sa-email-status]');
            if (status) { status.textContent = 'Saved.'; status.hidden = false; }
          } catch (e) {}
        });
      }

      function pickVariantForSize(size) {
        if (!variants.length) return null;
        var match = variants.filter(function (v) {
          return v.available && v.options && v.options.some(function (o) { return String(o).toUpperCase() === String(size).toUpperCase(); });
        });
        return match[0] || null;
      }

      function validateStep() {
        var stepEl = root.querySelector('[data-sa-step="' + state.step + '"]');
        if (!stepEl) return;
        var nextBtn = stepEl.querySelector('[data-sa-next]');
        if (!nextBtn) return;
        var valid = false;
        if (state.step === 'intro') valid = true;
        else if (state.step === 'height') {
          if (state.heightUnit === 'cm') valid = state.height_cm && state.height_cm >= 120 && state.height_cm <= 220;
          else valid = state.height_ft && state.height_ft >= 4 && state.height_ft <= 7;
        } else if (state.step === 'weight') {
          if (state.weightUnit === 'kg') valid = state.weight_kg && state.weight_kg >= 30 && state.weight_kg <= 200;
          else valid = state.weight_lb && state.weight_lb >= 66 && state.weight_lb <= 440;
        } else if (state.step === 'usual') valid = !!state.usual;
        else if (state.step === 'fit') valid = !!state.fit;
        nextBtn.disabled = !valid;
      }

      function compute() {
        var sizes = chart.sizes;
        // Synthesize ranges if missing
        var defaults = [[150,165],[160,173],[170,182],[178,190],[185,200],[193,210]];
        sizes.forEach(function (s, i) {
          if (!s.height_range) s.height_range = defaults[Math.min(i, defaults.length - 1)];
          if (!s.weight_range) {
            var hr = s.height_range;
            s.weight_range = [Math.round(hr[0] * 0.32), Math.round(hr[1] * 0.55)];
          }
        });
        var fitBias = chart.fit_bias || 'regular';
        var h = state.heightUnit === 'cm' ? Number(state.height_cm)
              : (Number(state.height_ft || 0) * 30.48 + Number(state.height_in || 0) * 2.54);
        var w = state.weightUnit === 'kg' ? Number(state.weight_kg)
              : Number(state.weight_lb || 0) * 0.4536;

        var scored = sizes.map(function (s, i) {
          var name = s.size || s.name || '';
          var score = 0;
          if (s.height_range && s.height_range.length === 2) {
            if (h >= s.height_range[0] && h <= s.height_range[1]) score += 40;
            else {
              var hDist = h < s.height_range[0] ? s.height_range[0] - h : h - s.height_range[1];
              score -= Math.min(35, hDist * 1.6);
            }
          }
          if (s.weight_range && s.weight_range.length === 2) {
            if (w >= s.weight_range[0] && w <= s.weight_range[1]) score += 40;
            else {
              var wDist = w < s.weight_range[0] ? s.weight_range[0] - w : w - s.weight_range[1];
              score -= Math.min(35, wDist * 1.6);
            }
          }
          if (state.usual && state.usual !== 'unknown') {
            if (name.toUpperCase() === state.usual.toUpperCase()) score += 12;
          }
          return { name: name, index: i, score: score };
        }).sort(function (a, b) { return b.score - a.score; });

        var baseIdx = scored[0].index;
        var adjusted = baseIdx;
        if (state.fit === 'slim' && fitBias !== 'slim' && baseIdx > 0) adjusted = baseIdx - 1;
        else if (state.fit === 'oversized' && fitBias !== 'oversized' && baseIdx < sizes.length - 1) adjusted = baseIdx + 1;
        else if (state.fit === 'boxy') adjusted = Math.min(sizes.length - 1, baseIdx + (fitBias === 'oversized' ? 1 : 2));

        var finalSizeObj = sizes[adjusted];
        var finalSize = finalSizeObj.size || finalSizeObj.name;
        state.result = finalSize;

        var resultEl = root.querySelector('[data-sa-result-size]');
        if (resultEl) resultEl.textContent = finalSize;
        var reason = root.querySelector('[data-sa-reasoning]');
        if (reason) {
          reason.textContent = 'Based on ' + Math.round(h) + ' cm, ' + Math.round(w) + ' kg, and a ' + (state.fit || 'regular') + ' fit preference.';
        }
        var cartSize = root.querySelector('[data-sa-cart-size]');
        if (cartSize) cartSize.textContent = finalSize;

        // Show garment measurements list
        var measEl = root.querySelector('[data-sa-measurements]');
        var listEl = root.querySelector('[data-sa-measurements-list]');
        if (listEl) {
          var labelMap = {
            chest: 'Chest', length: 'Length', shoulder: 'Shoulder', shoulders: 'Shoulders',
            waist: 'Waist', hip: 'Hip', sleeve: 'Sleeve', inseam: 'Inseam',
            width: 'Width', height: 'Height', front_rise: 'Front Rise',
            leg_opening: 'Leg Opening', front_crotch: 'Front Crotch', armpit: 'Armpit'
          };
          var skip = { size: 1, name: 1, height_range: 1, weight_range: 1 };
          var html = '';
          for (var k in finalSizeObj) {
            if (skip[k] || finalSizeObj[k] == null) continue;
            html += '<dt>' + (labelMap[k] || k) + '</dt><dd>' + finalSizeObj[k] + ' cm</dd>';
          }
          listEl.innerHTML = html;
          if (measEl) measEl.hidden = !html;
        }
      }

      function renderChart() {
        var container = root.querySelector('[data-sa-chart-table]');
        if (!container) return;
        var labelMap = {
          chest: 'Chest', length: 'Length', shoulder: 'Shoulder', shoulders: 'Shoulders',
          waist: 'Waist', hip: 'Hip', sleeve: 'Sleeve', inseam: 'Inseam',
          width: 'Width', height: 'Height', front_rise: 'Front Rise',
          leg_opening: 'Leg Opening', front_crotch: 'Front Crotch', armpit: 'Armpit'
        };
        var skip = { size: 1, name: 1, height_range: 1, weight_range: 1 };
        var fields = [], seen = {};
        chart.sizes.forEach(function (s) {
          for (var k in s) {
            if (skip[k] || seen[k] || s[k] == null) continue;
            seen[k] = 1; fields.push(k);
          }
        });
        var html = '<table><thead><tr><th>Size</th>';
        fields.forEach(function (f) { html += '<th>' + (labelMap[f] || f) + '</th>'; });
        html += '</tr></thead><tbody>';
        chart.sizes.forEach(function (s) {
          html += '<tr><td>' + (s.size || s.name || '') + '</td>';
          fields.forEach(function (f) { html += '<td>' + (s[f] != null && s[f] !== '' ? s[f] + ' cm' : '\u2014') + '</td>'; });
          html += '</tr>';
        });
        html += '</tbody></table>';
        container.innerHTML = html;
      }
    }

    function initAll() { document.querySelectorAll('.eros-sa').forEach(initRoot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
